function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_map-bank",
  "data-name": "Icon map-bank",
  d: "M33.523,26.238a17.209,17.209,0,0,0-6.661-2.8l-2.272-.536V13.2l.308.126A5.738,5.738,0,0,1,28,18.212h7.733C35.6,14.1,34.075,11.052,31.175,8.9A15.769,15.769,0,0,0,24.59,6.091V.72h-7.2V5.926A14.107,14.107,0,0,0,9.476,9.153a11.067,11.067,0,0,0-3.808,8.6q0,5.669,3.892,8.334c1.453,1.007,4.071,1.943,7.827,2.809V39.4a6.189,6.189,0,0,1-3.2-1.9,6.516,6.516,0,0,1-1.467-3.861H5.04A11.066,11.066,0,0,0,9.4,43,16.113,16.113,0,0,0,17.387,46.1v4.012h7.2V46.164a15.24,15.24,0,0,0,8.3-3.3,11.052,11.052,0,0,0,4.08-8.765Q36.964,28.955,33.523,26.238ZM14.988,20.253a3.307,3.307,0,0,1-1.875-3.087,3.978,3.978,0,0,1,1.9-3.508,7.285,7.285,0,0,1,2.373-.974v8.462A12.406,12.406,0,0,1,14.988,20.253ZM25.766,39.192a10.021,10.021,0,0,1-1.176.315V30.559a12.85,12.85,0,0,1,2.93,1.2,3.3,3.3,0,0,1,1.686,2.958C29.205,36.892,28.058,38.391,25.766,39.192Z",
  transform: "translate(-5.04 -0.72)",
  fill: "#0078d7"
});

function SvgIconMapBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.924,
    height: 49.388,
    viewBox: "0 0 31.924 49.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapBank);
export default __webpack_public_path__ + "static/media/icon-map-bank.aef19516.svg";
export { ForwardRef as ReactComponent };